<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>
      <!-- Nome -->
      <d-col md="8" class="form-group">
        <label for="feName">Nome</label>
        <d-form-input
          :state="hasErrorField('name')"
          type="text"
          id="feName"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Email -->
      <d-col md="4" class="form-group">
        <label for="feContactEmail">E-mail</label>
        <d-form-input
          :state="hasErrorField('email')"
          type="text"
          v-model="model.email"
          id="feContactEmail"
          placeholder="E-mail"
        />
        <d-form-invalid-feedback>Email é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Telefone -->
      <d-col md="4" class="form-group">
        <label for="feTelefone">Telefone</label>
        <input-phone id="feTelefone" :model.sync="model.phone" />
      </d-col>

      <!-- Celular -->
      <d-col md="4" class="form-group">
        <label for="feCelular">Celular</label>
        <input-phone id="feCelular" :model.sync="model.cellphone" />
      </d-col>

      <!-- Site -->
      <d-col md="4" class="form-group">
        <label for="feSite">Site</label>
        <d-form-input
          type="text"
          id="feSite"
          placeholder="Site"
          v-model="model.site"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-col
        md="4"
        class="d-flex justify-content-center-center align-items-center"
      >
        <d-checkbox
          toggle
          :checked="model.direct_sales == 1"
          @change="handleCheckDirectSales"
          class="custom-toggle-sm"
        >
          <span>Venda direta</span>
        </d-checkbox>
      </d-col>

      <!-- Responsável -->
      <d-col md="4" class="form-group">
        <label for="feResponsible">Responsável</label>
        <d-form-input
          type="text"
          id="feResponsible"
          placeholder="Responsável"
          v-model="model.responsible"
        />
      </d-col>

      <!-- Facebook -->
      <d-col md="4" class="form-group">
        <label for="feFacebook">Facebook</label>
        <d-form-input
          type="text"
          id="feFacebook"
          placeholder="Facebook"
          v-model="model.social_medias.facebook"
        />
      </d-col>

      <!-- Instagram -->
      <d-col md="4" class="form-group">
        <label for="feInstagram">Instagram</label>
        <d-form-input
          type="text"
          id="feInstagram"
          placeholder="Instagram"
          v-model="model.social_medias.instagram"
        />
      </d-col>

      <!-- Supervisor -->
      <d-col
        md="4"
        class="form-group"
        v-if="model.supervisor_id || !isSupervisor"
      >
        <label for="feSupervisorId">Supervisor</label>
        <d-form-input
          v-if="model.supervisor_id && isSupervisor"
          type="text"
          id="feSupervisorId"
          :disabled="isSupervisor"
          v-model="model.supervisor.name"
        />
        <d-select v-else v-model="model.supervisor_id" id="feSupervisorId">
          <option
            :value="option.id"
            v-for="(option, index) in supervisorsOptions"
            :key="index"
          >
            {{ option.name }}
          </option>
        </d-select>
      </d-col>

      <!-- Regional -->
      <d-col
        md="4"
        class="form-group"
      >
        <label for="feRegionalId">Regional</label>
        <d-select v-model="model.regional" id="feRegionalId">
          <option
            :value="option.value"
            v-for="(option, index) in regionalOptions"
            :key="index"
          >
            {{ option.text }}
          </option>
        </d-select>
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-tabs
        class="mb-4 w-100 px-5px"
        nav-class="border-bottom-0"
        content-class="border rounded-bottom rounded-right"
        ref="tabs"
      >
        <d-tab title="Endereço" class="p-3 pt-3">
          <addresses :model.sync="model.address" ref="address" />
        </d-tab>
        <d-tab title="Regiões" class="p-1 pt-3" v-if="$route.params.id" active>
          <regions :model.sync="model" />
        </d-tab>
        <d-tab title="Indicações" class="p-1 pt-3" v-if="model.id">
          <indicators :id="model.id" ref="indicators" />
        </d-tab>
      </d-tabs>
    </d-form-row>
    <d-row v-if="!$route.params.id">
      <d-col cols="12">
        <div class="control__button d-flex justify-content-end">
          <d-button type="submit" class="btn-primary">Salvar</d-button>
        </div>
      </d-col>
    </d-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Config from '_config';
import mixin from '_common/mixins/ValidateForm';
import { CloneDeep, kitConditionOptions, regionalOptions } from '_utils';
import InputPhone from '_shared/InputPhone.vue';
import DistributorService from '_services/rest/modules/distributor';
import SupervisorService from '_services/rest/modules/supervisor';
import Addresses from './Addresses.vue';
import Regions from './Regions';
import Indicators from './Indicators';
import { MODEL, _LOAD_MODEL_ } from './DistributorModel';

export default {
  name: 'distributor-form',
  mixins: [mixin],
  components: {
    InputPhone,
    Addresses,
    Regions,
    Indicators,
  },
  data() {
    return {
      model: CloneDeep(MODEL),
      kitConditionOptions,
      regionalOptions,
      supervisorsOptions: null,
      errors: {
        name: { required: false },
        email: { required: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    isSupervisor() {
      const { user } = this.$store.state.user;
      if (user && user.settings.role.id === Config.SUPERVISOR_ROLE_ID) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(['activeAlert', 'checkAdmin']),
    getSupervisors() {
      return SupervisorService.getListAll().then(response => {
        const defaultOption = { id: null, name: 'Selecione Supervisor' };
        const options = response.list.map(supervisor => ({
          id: supervisor.id,
          name: supervisor.name,
        }));

        this.supervisorsOptions = [defaultOption, ...options];
      });
    },
    save() {
      if (this.checkForm()) {
        if (this.isSupervisor) this.setSupervisorId();
        return DistributorService.save(this.model)
          .then(response => {
            this.success(response);
            if (!this.$route.params.id) {
              this.$router.push(`/admin/distribuidores/${response.id}`);
            }
          })
          .catch(error => {
            this.activeAlert({
              message: `${error.message} <br/> ${error.data}`,
              theme: 'danger',
            });
          });
      }
      return null;
    },
    updateTabs() {
      setTimeout(() => {
        if (this.$refs.tabs) {
          this.$refs.tabs.updateTabs();
        }
      }, 10);
    },
    success() {
      this.activeAlert({
        message: 'Distribuidor salvo com sucesso',
        theme: 'success',
      });
    },
    setSupervisorId() {
      if (!this.$route.params.distributorId) {
        const { user } = this.$store.state.user;
        this.model.supervisor_id = user.id;
      }
    },
    handleCheckDirectSales(value) {
      this.model.direct_sales = value;
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = {
        ...newValue,
      };
      this.updateTabs();
    });
    if (!this.isSupervisor) this.getSupervisors();
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
};
</script>
<style scoped>
.px-5px {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
